/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconDiagram = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M18 16c-.104 0-.208 0-.312.032l-1.288-2.6A2 2 0 0 0 15 10c-.104 0-.2 0-.312.032l-1.304-2.6C13.768 7.072 14 6.568 14 6a2 2 0 0 0-4 0c0 .568.232 1.072.608 1.432l-1.296 2.6C9.2 10 9.104 10 9 10a2 2 0 0 0-1.4 3.432l-1.288 2.6C6.208 16 6.104 16 6 16a2 2 0 1 0 2 2 1.98 1.98 0 0 0-.608-1.432l1.296-2.6C8.8 14 8.896 14 9 14c.104 0 .2 0 .312-.032l1.304 2.6C10.24 16.928 10 17.44 10 18a2 2 0 1 0 2-2c-.104 0-.208 0-.312.032l-1.288-2.6c.368-.36.6-.864.6-1.432s-.232-1.072-.6-1.432l1.288-2.6C11.792 8 11.896 8 12 8c.104 0 .208 0 .312-.032l1.288 2.6A2 2 0 0 0 15 14c.104 0 .2 0 .312-.032l1.304 2.6C16.24 16.928 16 17.44 16 18a2 2 0 1 0 2-2Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconDiagram.displayName = 'IconDiagram';
export default IconDiagram;
